import { render } from "./k-bignumbers-repeater.vue?vue&type=template&id=0ea407c7"
import script from "./k-bignumbers-repeater.vue?vue&type=script&lang=js"
export * from "./k-bignumbers-repeater.vue?vue&type=script&lang=js"

import "./k-bignumbers-repeater.vue?vue&type=style&index=0&id=0ea407c7&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__